import { atom } from 'jotai';

export const isDeletingAtom = atom(false);

export const deleteMyMenuIdsAtom = atom<string[]>([]);
